module.exports = __webpack_public_path__ + "img/11_1801_ken.5fa05b37.jpg";